import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/splice';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import classNames from 'classnames';
import { difference } from 'lodash-es';
import '../../../utils/fetcher.js';
import { prependPrefix } from '../../../utils/style.js';
import { SEARCH_ITEM_CLASSNAME, SEARCH_KEYWORD_CLASSNAME } from '../utils/index.js';
import { SuggestionList } from './suggestion-list.js';
import { getLatestKeywords, getSearchHistoryFromLocalStorage, setSearchHistoryToLocalStorage } from '../utils/history.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SearchHistory = /*#__PURE__*/function (_SuggestionList) {
  _inherits(SearchHistory, _SuggestionList);

  var _super = _createSuper(SearchHistory);

  function SearchHistory(props) {
    var _this;

    _classCallCheck(this, SearchHistory);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "storageChangeHandler", function () {
      var keywordList = _this.state.keywordList;
      var local = getLatestKeywords();

      if (difference(local, keywordList).length) {
        _this.setState({
          keywordList: local
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleHistoryDelete", function (keyword, e) {
      e.stopPropagation();
      e.preventDefault();
      var list = getSearchHistoryFromLocalStorage();

      _spliceInstanceProperty(list).call(list, _indexOfInstanceProperty(list).call(list, keyword), 1);

      setSearchHistoryToLocalStorage(list);

      _this.setState({
        keywordList: getLatestKeywords(list)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClearAllHistory", function () {
      setSearchHistoryToLocalStorage([]); // FIXME: storageChangeHandler 也会执行此操作，此处为冗余操作，来保证 keywordList 清空

      _this.setState({
        keywordList: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeywordClick", function (keyword, e) {
      // TODO: 将组件内判断 type 的逻辑统一处理
      if (_this.props.type !== 'large') {
        return;
      }

      e.preventDefault();

      _this.submit(keyword);
    });

    _this.state = {
      active: -1,
      keywordList: getLatestKeywords()
    };
    _this.containerRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(SearchHistory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addKeydownListener();
      window.addEventListener('storage', this.storageChangeHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeKeydownListener();
      window.removeEventListener('storage', this.storageChangeHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var type = this.props.type;
      var _this$state = this.state,
          active = _this$state.active,
          keywordList = _this$state.keywordList;
      var isLargeType = type === 'large';

      if (!keywordList.length) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: prependPrefix('search-suggestion')
      }, /*#__PURE__*/React.createElement("span", {
        className: "suggestion-title"
      }, "\u641C\u7D22\u5386\u53F2"), /*#__PURE__*/React.createElement("ul", {
        className: "suggestion-content",
        ref: this.containerRef
      }, _mapInstanceProperty(keywordList).call(keywordList, function (keyword, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: keyword,
          title: keyword,
          className: classNames(SEARCH_ITEM_CLASSNAME, {
            active: active === i
          })
        }, /*#__PURE__*/React.createElement("button", {
          className: "suggestion-item-delete-btn",
          onClick: function onClick(e) {
            return _this2.handleHistoryDelete(keyword, e);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "suggestion-delete"
        })), /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({
          className: SEARCH_KEYWORD_CLASSNAME
        }, !isLargeType && {
          href: SuggestionList.getSearchLink(keyword),
          target: '_blank'
        }), {}, {
          onClick: function onClick(e) {
            return _this2.handleKeywordClick(keyword, e);
          }
        }), keyword));
      })), isLargeType && /*#__PURE__*/React.createElement("button", {
        className: "suggestion-content-clear-btn",
        onClick: this.handleClearAllHistory
      }, "\u6E05\u7A7A\u641C\u7D22\u5386\u53F2"));
    }
  }]);

  return SearchHistory;
}(SuggestionList);

export { SearchHistory };
